import { Editor, Element, Transforms, Path, BaseRange } from 'slate';
import { ReactEditor } from 'slate-react';
import { BaseMention, CustomEditor, CustomMention } from '../../../../models/slate-editor';
import { ThirdPartyProfileSearchType } from '../../../../models/graphql';

export const withMentions = (editor: Editor) => {
  const { isInline, isVoid } = editor;

  editor.isInline = element => {
    return element.type === 'mention' ? true : isInline(element);
  };

  editor.isVoid = element => {
    return element.type === 'mention' ? true : isVoid(element);
  };

  return editor;
};

export const insertMention = (editor: CustomEditor, mentionObject: BaseMention, range: BaseRange) => {
  const mention: CustomMention = {
    type: 'mention',
    ...mentionObject,
    children: [{ text: '' }]
  };
  const { anchor, focus } = range;
  const { path: anchorPath } = anchor;
  const { path: focusPath } = focus;
  if (!Path.equals(anchorPath, focusPath)) {
    throw new Error('Mention insert path is invalid');
  }
  const startRange = { anchor: { path: anchorPath, offset: anchor.offset ? anchor.offset - 1 : 0 }, focus: anchor };
  const endRange = { anchor: focus, focus: { path: focusPath, offset: focus.offset + 1 } };
  const startText = Editor.string(editor, startRange);
  const endText = Editor.string(editor, endRange);
  if (startText && startText !== ' ') {
    Transforms.insertText(editor, ' ', { at: anchor });
    Transforms.insertNodes(editor, mention, {
      at: {
        anchor: { path: anchor.path, offset: anchor.offset + 1 },
        focus: { path: focus.path, offset: focus.offset + 1 }
      },
      select: true
    });
  } else {
    Transforms.insertNodes(editor, mention, {
      at: range,
      select: true
    });
  }
  const { selection } = editor;
  const parentPath = selection && Path.parent(selection.focus.path);
  const nextPath = parentPath && Path.next(parentPath);
  if (endText !== ' ') {
    nextPath && Transforms.insertText(editor, ' ', { at: { path: nextPath, offset: 0 } });
  }
  nextPath &&
    Transforms.select(editor, { anchor: { path: nextPath, offset: 1 }, focus: { path: nextPath, offset: 1 } });
  ReactEditor.focus(editor);
};

export const removeMention = (editor: CustomEditor): boolean => {
  let shouldShowToast = false;
  const mentionElements = Editor.nodes(editor, {
    at: [], // Path of Editor, we want root
    match: node => Element.isElement(node) && node.type === 'mention'
    // mode defaults to "all", so this also searches the Editor's children
  }) as unknown as [CustomMention, Path][]; // we need to cast to unknown to enable iteration
  for (const nodeEntry of mentionElements) {
    const el = nodeEntry[0];
    shouldShowToast = true;
    const hasAt = el.method === ThirdPartyProfileSearchType.TWITTER_USER;
    const text = hasAt ? el.username : el.displayName;
    Transforms.select(editor, nodeEntry[1]);
    Transforms.delete(editor);
    Transforms.insertNodes(editor, { text: `@${text}` });
  }
  return shouldShowToast;
};
